import { createFileRoute } from "@tanstack/react-router";

import AdminLayout from "@/app/admin/AdminLayout";

export const Route = createFileRoute("/admin")({
  component: AdminLayout,
});
